module.exports = __webpack_public_path__ + "img/1.b820ea4 1.6c01c2d.svg";